<template>
  <div>
    <v-alert v-if="precioDefecto == null" text dense>{{ mensajeError(escenario, solucionConstructiva) }}</v-alert>
    <div class="caption font-weight-bold">{{ titulo(solucionConstructiva) }}</div>
    <v-text-field v-model="solucionConstructiva.costeUnitarioAcabado" outlined type="number">
      <template v-slot:append>
        €/m&sup2;
      </template>
    </v-text-field>
  </div>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import DescripcionesServicio from "../../../../../../comunes/servicios/DescripcionesServicio";

export default {
  name: "InputPrecioComponente",
  model: {
    prop: 'correct',
    event: 'change'
  },
  props: {
    escenario: {type: Object, required: true},
    solucionConstructiva: {type: Object, required: true},
    proyectoId: {type: [Number, String], required: true},
    correcto: {type: Boolean, default: false}
  },
  data: function () {
    return {
      precioDefecto: null,
      fachadaConsultada: null,
      intensidadTransitoConsultada: null,
    }
  },
  mounted() {
    this.cargarPrecioPorDefecto(this.escenario, this.solucionConstructiva, true);
    this.emitirCorrecto(this.precioEsCorrecto(this.solucionConstructiva));
  },
  watch: {
    escenario: {
      handler(val) {
        this.emitirCorrecto(this.precioEsCorrecto(this.solucionConstructiva));
        this.cargarPrecioPorDefecto(val, this.solucionConstructiva);
      },
      deep: true
    },
    solucionConstructiva: {
      handler(val) {
        this.emitirCorrecto(this.precioEsCorrecto(val));
        this.cargarPrecioPorDefecto(this.escenario, val);
      },
      deep: true
    }
  },
  methods: {
    titulo(solCons) {
      return DescripcionesServicio.materialSolCons(solCons);
    },
    cargarPrecioPorDefecto(escenario, solucionConstructiva, desdeMounted) {
      if (typeof desdeMounted === "undefined") desdeMounted = false;
      if (typeof escenario === "undefined" || escenario == null) return;
      if (typeof solucionConstructiva === "undefined") return;

      let params = {};
      switch (solucionConstructiva.tipoSolucion.codigo) {
        case 'facade_rehabilitation':
          if (solucionConstructiva.typeFacade == null) return;
          if (this.fachadaConsultada === solucionConstructiva.typeFacade.code) return;
          params = {
            'forceTypeFacade': solucionConstructiva.typeFacade.code
          };
          this.fachadaConsultada = solucionConstructiva.typeFacade.code;
          break;
        case "horizontal_rehabilitation":
          if (escenario.trafficIntensity == null) return;
          if (this.intensidadTransitoConsultada === escenario.trafficIntensity.code) return;
          params = {
            'forceTrafficIntensity': escenario.trafficIntensity.code
          };
          this.intensidadTransitoConsultada = escenario.trafficIntensity.code;
          break;
        case "obra_nueva_horizontal":
          if (escenario.intensidadTransito == null) return;
          if (this.intensidadTransitoConsultada === escenario.intensidadTransito.codigo) return;
          params = {
            'forceTrafficIntensity': escenario.intensidadTransito.codigo
          };
          this.intensidadTransitoConsultada = escenario.intensidadTransito.codigo;
          break;
        case "obra_nueva_fachada":
          if (solucionConstructiva.tipoFachada == null) return;
          if (this.fachadaConsultada === solucionConstructiva.tipoFachada.codigo) return;
          params = {
            'forceTypeFacade': solucionConstructiva.tipoFachada.codigo
          };
          this.fachadaConsultada = solucionConstructiva.tipoFachada.codigo;
          break;
        default:
          if (this.precioDefecto !== null) return;
      }

      let url = `proyecto/${this.proyectoId}/solucion-constructiva/${this.solucionConstructiva.id}/precio-defecto`;
      const habiaPrecioPersonalizado = this.solucionConstructiva.costeUnitarioAcabado != null
          && this.precioDefecto != null
          && this.solucionConstructiva.costeUnitarioAcabado !== this.precioDefecto;

      HttpHelper.get(url, params).then(data => {
        this.precioDefecto = data;
        if (this.solucionConstructiva.costeUnitarioAcabado === null || (!desdeMounted && !habiaPrecioPersonalizado))
          this.solucionConstructiva.costeUnitarioAcabado = data;
      }).catch(() => {
        this.precioDefecto = null;
      });
    },
    emitirCorrecto(value) {
      this.$emit('change', value);
    },
    precioEsCorrecto(solucionCostructiva) {
      if (solucionCostructiva.costeUnitarioAcabado == null
          || solucionCostructiva.costeUnitarioAcabado == ''
          || solucionCostructiva.costeUnitarioAcabado == 0)
        return false;

      return true;
    },
    mensajeError(escenario, solucionConstructiva) {
      if (typeof escenario === "undefined" || escenario == null) return;
      if (typeof solucionConstructiva === "undefined") return;

      switch (solucionConstructiva.tipoSolucion.codigo) {
        case 'facade_rehabilitation':
          if (solucionConstructiva.typeFacade == null) {
            return this.$t("error_tipo_fachada");
          }
          break;
        case "horizontal_rehabilitation":
          if (escenario.trafficIntensity == null) {
            return this.$t("error_intensidad_transito");
          }
          break;
        case "obra_nueva_horizontal":
          if (escenario.intensidadTransito == null) {
            return this.$t("error_intensidad_transito");
          }
          break;
        case "obra_nueva_fachada":
          if (escenario.intensidadTransito == null) {
            return this.$t("error_tipo_fachada");
          }
      }
      return "";
    },
  }
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "error_tipo_fachada": "Se debe seleccionar el tipo de fachada para poder calcular el precio por defecto",
    "error_intensidad_transito": "Se debe seleccionar la intensidad de tránsito para poder calcular el precio por defecto"
  }
}
</i18n>
<!--@formatter:on-->